import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Dimmer, Loader } from 'semantic-ui-react';
import { Route, Switch, Redirect } from 'react-router-dom';

import * as showActions from '../store/show/showActions';
import * as showPageActions from '../store/showPage/showPageActions';
import * as showSeasonActions from '../store/showSeason/showSeasonActions';

// components
import Home from '../components/Home';
import Header from '../components/Header';
import Footer from '../components/Footer';
import HowToApply from '../components/HowToApply';
import VideoTips from '../components/VideoTips';
import OpenCalls from '../components/OpenCalls';
import FAQs from '../components/FAQs';
import Terms from '../components/Terms';
import Contact from '../components/Contact';
import Apply from '../components/Apply';
import ApplySuccess from '../components/ApplySuccess';
import EligibilityRequirements from '../components/EligibilityRequirements';
import ConsentPage from '../components/Consent';

console.log = console.warn = console.error = () => {};

class Main extends PureComponent {
  static propTypes = {
    getShowInformation: PropTypes.func.isRequired,
    getShowPages: PropTypes.func.isRequired,
    getShowSeason: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    show: PropTypes.object.isRequired,
    pages: PropTypes.array.isRequired,
    season: PropTypes.object.isRequired,
  };

  componentDidMount() {

    this.props.getShowInformation();
    this.props.getShowPages();
    this.props.getShowSeason();
  }

  render() {
    const { show, pages, loading, season } = this.props;
    if (loading) {
      return (
        <Dimmer active inverted>
          <Loader size="large">Loading</Loader>
        </Dimmer>
      );
    }
    return (
      <div>
        <Header show={show} pages={pages} season={season} />
        <Switch>
          <Route
            path="/home"
            exact
            render={() => (
              <Home
                show={show}
                season={season}
                page={pages.find(item => item.pageNameC === 'Home')}
              />
            )}
          />
          <Route
            path="/howtoapply"
            render={() => (
              <HowToApply
                show={show}
                season={season}
                page={pages.find(item => item.pageNameC === 'How to Apply')}
              />
            )}
          />
          <Route
            path="/videotips"
            exact
            render={() => (
              <VideoTips
                show={show}
                season={season}
                page={pages.find(item => item.pageNameC === 'Video Tips')}
              />
            )}
          />
          <Route
            path="/opencalls"
            exact
            render={() => (
              <OpenCalls
                show={show}
                season={season}
                page={pages.find(item => item.pageNameC === 'Open Calls')}
              />
            )}
          />
          <Route
            path="/faq"
            exact
            render={() => (
              <FAQs
                show={show}
                season={season}
                page={pages.find(item => item.pageNameC === 'FAQ')}
              />
            )}
          />
          <Route
            path="/terms"
            exact
            render={() => <Terms season={season} show={show} />}
          />
          <Route path="/terms" exact render={() => <Terms show={show} />} />
          <Route
            path="/contact"
            exact
            render={() => (
              <Contact
                show={show}
                season={season}
                page={pages.find(item => item.pageNameC === 'Contact')}
              />
            )}
          />
          <Route
            path="/apply/consent"
            exact
            render={() => <ConsentPage season={season} show={show} />}
          />
          <Route
            path="/apply"
            exact
            render={() => <Apply season={season} show={show} />}
          />
          <Route
            path="/applySuccess"
            exact
            render={() => (
              <ApplySuccess show={show} hexColorCodeC={season.hexColorCodeC} />
            )}
          />
          <Route
            path="/eligibility"
            exact
            render={() => (
              <EligibilityRequirements season={season} show={show} />
            )}
          />
          <Redirect to="/home" />
        </Switch>
        <Footer season={season} show={show} />
      </div>
    );
  }
}

const mapStatesToProps = state => ({
  show: state.show.show,
  loading: state.showPage.loading,
  pages: state.showPage.pages,
  season: state.showSeason.season,
});

const mapDispatchToProps = dispatch => ({
  getShowInformation: () => dispatch(showActions.getShowInformation()),
  getShowPages: () => dispatch(showPageActions.getShowPages()),
  getShowSeason: () => dispatch(showSeasonActions.getShowSeason()),
});

export default connect(mapStatesToProps, mapDispatchToProps)(Main);



// WEBPACK FOOTER //
// ./src/pages/Main.js